import { countryCodes } from '../constants/constants';
const countryRegionData = require('../api/countryData.json');

const getCountryAndProvince = (countryCode, stateCode) => {
  const country = countryRegionData.find((country) => {
    return country.countryShortCode === countryCode;
  });
  const countryName = country ? country.countryName : '';
  const provinceData = country
    ? country.regions.find((region) => {
        return region.shortCode === stateCode;
      })
    : null;
  const provinceName = provinceData ? provinceData.name : '';
  return [countryName, provinceName];
};

const getCountryData = (countryCode) => {
  const countryData = countryRegionData.find((country) => {
    return country.countryShortCode === countryCode;
  });
  return countryData;
};

const getActiveCountries = () => {
  let activeCountriesList = [];

  for (const code in countryCodes) {
    activeCountriesList.push(getCountryData(code));
  }

  return activeCountriesList;
};

const getActiveCountriesNameArray = () => {
  let activeCountriesList = getActiveCountries();
  let activeCountriesNameList = [];

  for (const index in activeCountriesList) {
    activeCountriesNameList.push({
      countryName: activeCountriesList[index].countryName,
      countryCode: activeCountriesList[index].countryShortCode,
    });
  }

  return activeCountriesNameList;
};

const getActiveCountryStatesArray = (countryCode) => {
  let activeCountriesList = getActiveCountries();

  const { regions } = activeCountriesList.find((country) => country.countryShortCode === countryCode);

  return regions;
};

export { getCountryAndProvince, getCountryData, getActiveCountries, getActiveCountriesNameArray, getActiveCountryStatesArray };
